import { format } from '@seek/currency';

import { isPositiveNumber } from 'src/app/utils/isPositiveNumber';

export const formatLabel = (
  value: number | null | undefined,
  options: { locale: string; currency: string },
): string => {
  if (!isPositiveNumber(value)) {
    return '';
  }
  const { locale, currency } = options;
  return format(value, {
    locale,
    currency,
    dropFraction: true,
    display: 'noSymbol',
    notation: 'compact',
  });
};
